import { message } from "antd";
import { v4 } from "uuid";
import { baseRequest } from "../../util/Api";

export const getApis = () => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/apis")
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
      })
  })
}

export const getApi = (id) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/apis/" + id)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        message.error(e)
      })
  })
}

export const newApi = (payload) => {
  return new Promise((resolve) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Membuat API baru ..." })
    baseRequest("post", "/apis", null, payload)
      .then((newData) => {
        message.success({ key, type: 'success', content: "API baru berhasil dibuat" })
        resolve(newData);
      })
      .catch((e) => {
        message.error({ key, type: 'error', content: e })
      });
  });
}

export const deleteApi = (id) => {
  return new Promise((resolve, reject) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Menghapus API ..." })
    baseRequest("delete", "/apis/" + id)
      .then((data) => {
        message.success({ key, type: 'success', content: "API berhasil dihapus" })
        resolve(data)
      }).catch((e) => {
        message.error({ key, type: 'error', content: e })
        reject(e)
      })
  })
}

export const updateApi = (id, payload) => {
  return new Promise((resolve, reject) => {
    const key = v4();
    message.open({ key, type: 'loading', content: "Memperbarui API ..." })
    baseRequest("put", "/apis/" + id, null, payload)
      .then((data) => {
        message.success({ key, type: 'success', content: "API berhasil diperbarui" })
        resolve(data)
      }).catch((e) => {
        message.error({ key, type: 'error', content: e })
        reject(e)
      })
  })
}


// export const updateConfiguration = (configuration) => {
//   return new Promise((resolve) => {
//     const key = v4();
//     message.open({ key, type: 'loading', content: "Memperbarui konfigurasi ..." })
//     baseRequest("put", "/configurations/" + configuration.name, null, configuration)
//       .then((newData) => {
//         message.success({ key, type: 'success', content: "Memperbarui konfigurasi berhasil" })
//         resolve(newData);
//       })
//       .catch((e) => {
//         message.error({ key, type: 'error', content: e })
//       });
//   });
// }